import "./index.css";
import { clsx } from "clsx";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import type { IBadgeProps, IBadgeSize } from "./types";

export const Badge = (props: IBadgeProps) => {
  const {
    ariaLabel,
    anchor,
    content,
    className,
    color = "brand",
    hide = false,
    ref,
  } = props;
  const isMobile = useMediaQuery("(max-width: 639px)");
  const size: IBadgeSize = props.size || (isMobile ? "md" : "sm");

  const rootClass = clsx("nuco-badge", `nuco-badge--${size}`, className);

  return (
    <div ref={ref} className={rootClass}>
      {anchor}
      {!hide && (
        <div
          className={clsx("nuco-badge__badge", `nuco-color-${color}`)}
          role="status"
          aria-label={ariaLabel || `Badge: ${content}`}
        >
          {/* xs is a dot: too small for digits, so the count is announced only. */}
          <span className={clsx(size === "xs" && "nuco-badge__hidden")}>
            {content}
          </span>
        </div>
      )}
    </div>
  );
};
